/*
  Minutedrone, backlog t7 (13/10/2026).
  Bascule « TTC | HT » du panier (tiroir et page panier), rendue par snippets/minutedrone-panier-bascule.liquid.
  - Le serveur rend chaque prix du panier deux fois (.md-prix-ttc et .md-prix-ht) ; le CSS du snippet affiche l'un ou
    l'autre selon l'attribut data-md-tax-mode de <html>. Ce script ne calcule et n'écrit aucun prix.
  - Même clé localStorage que la bascule des fiches produit (assets/minutedrone-tax-toggle.js) : le choix fait sur une
    fiche vaut dans le panier, et inversement.
  - Un script en ligne de snippets/cart-products.liquid pose déjà l'attribut avant l'affichage du panier.
  - Aucun effet sur le montant payé : le paiement reste TTC.
*/
(function () {
  'use strict';

  if (window.mdPanierBascule) return;
  window.mdPanierBascule = true;

  var CLE = 'minutedrone-tax-mode';
  var ATTRIBUT = 'data-md-tax-mode';
  var BOUTONS = '.md-tax-toggle__btn';
  var BOUTONS_PANIER = '.md-panier-bascule ' + BOUTONS;
  var racine = document.documentElement;
  var clicInterne = false;

  function modeAffiche() {
    return racine.getAttribute(ATTRIBUT) === 'ht' ? 'ht' : 'ttc';
  }

  function modeEnregistre() {
    try {
      return window.localStorage.getItem(CLE) === 'ht' ? 'ht' : 'ttc';
    } catch (erreur) {
      // Stockage refusé (navigation privée stricte) : le choix vaut pour la page seulement.
      return modeAffiche();
    }
  }

  function enregistrer(mode) {
    try {
      window.localStorage.setItem(CLE, mode);
    } catch (erreur) {
      // Voir modeEnregistre.
    }
  }

  // Les boutons arrivent du serveur sur « TTC » : on les aligne sur le mode affiché (classe et aria-pressed).
  function synchroniserBoutons() {
    var mode = modeAffiche();
    var boutons = document.querySelectorAll(BOUTONS_PANIER);

    for (var i = 0; i < boutons.length; i++) {
      var actif = boutons[i].getAttribute('data-tax-mode') === mode;
      var presse = actif ? 'true' : 'false';

      if (boutons[i].classList.contains('is-active') !== actif) boutons[i].classList.toggle('is-active', actif);
      if (boutons[i].getAttribute('aria-pressed') !== presse) boutons[i].setAttribute('aria-pressed', presse);
    }
  }

  function appliquer(mode) {
    if (racine.getAttribute(ATTRIBUT) !== mode) racine.setAttribute(ATTRIBUT, mode);
    synchroniserBoutons();
  }

  // La bascule des fiches n'expose aucune fonction : un clic sur son bouton met à jour tous ses prix.
  function synchroniserFiche(mode) {
    var bouton = document.querySelector('[data-tax-price] ' + BOUTONS + '[data-tax-mode="' + mode + '"]');

    if (!bouton || bouton.getAttribute('aria-pressed') === 'true') return;

    clicInterne = true;
    try {
      bouton.click();
    } finally {
      clicInterne = false;
    }
  }

  document.addEventListener('click', function (evenement) {
    if (clicInterne) return;

    var cible = evenement.target;
    var bouton = cible && cible.closest ? cible.closest(BOUTONS) : null;
    if (!bouton) return;

    var mode = bouton.getAttribute('data-tax-mode') === 'ht' ? 'ht' : 'ttc';

    if (bouton.closest('.md-panier-bascule')) {
      enregistrer(mode);
      appliquer(mode);
      synchroniserFiche(mode);
    } else {
      // Bascule d'une fiche produit : son script a déjà enregistré le choix, le panier suit.
      appliquer(mode);
    }
  });

  // Choix fait dans un autre onglet, ou page rendue par le cache du navigateur (retour arrière).
  function reprendre() {
    var mode = modeEnregistre();
    appliquer(mode);
    synchroniserFiche(mode);
  }

  window.addEventListener('storage', function (evenement) {
    if (evenement.key === CLE || evenement.key === null) reprendre();
  });

  window.addEventListener('pageshow', function (evenement) {
    if (evenement.persisted) reprendre();
  });

  // Panier re-rendu par Horizon (quantité, suppression, ajout, code de réduction) : des boutons neufs peuvent arriver.
  if ('MutationObserver' in window) {
    new MutationObserver(synchroniserBoutons).observe(racine, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-pressed'],
    });
  }

  appliquer(modeEnregistre());
})();
